module.exports = __webpack_public_path__ + "img/ftr-call.37839ae4.svg";